"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
// this is a button who's size is in the middle of small and medium
// temporarily adding this as a styled component before we actually add into the theme
// TODO: if this will be used in multiple places, add to theme
var MidButton = (0, styles_1.styled)(Button_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '&.MuiButton-sizeSmall': {
            height: theme.spacing(3.5),
            padding: theme.spacing(0.5, 2),
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(MidButton, {
    size: 'small',
    variant: 'outlined', // should the 28px be for LineButtons only?
});
